var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"tg-list-card--group",attrs:{"gutter":5,"type":"flex","justify":"start"}},[_vm._l((_vm.lists),function(list,i){return [_c('tg-list-card',{key:i,attrs:{"title":list.label,"agent_name":list.agent_name,"data":list.data,"disabled":_vm.disabled},on:{"on-click":_vm.handleListClick}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }